// The Product Improvement credits notice is hosted once, in containers/App,
// between "Jobs to do" and "What's new". Same contract as the jobs host
// (components/AdminJobs/events.js): while it is still asking whether there is
// anything to say ('pending') or has its dialog open ('open'), it says so on
// <body>, and What's new reads the attribute by name and waits.
export const PIP_CREDITS_ATTR = 'data-pip-credits';
export const PIP_CREDITS_EVENT = 'pipcredits:change';

export const markPipCredits = state => {
  if (typeof document === 'undefined') return;
  if (state) document.body.setAttribute(PIP_CREDITS_ATTR, state);
  else document.body.removeAttribute(PIP_CREDITS_ATTR);
  window.dispatchEvent(new CustomEvent(PIP_CREDITS_EVENT, { detail: { state: state || null } }));
};

export const isPipCreditsBlocking = () => {
  if (typeof document === 'undefined') return false;
  const state = document.body.getAttribute(PIP_CREDITS_ATTR);
  return state === 'pending' || state === 'open';
};

// Where each kind of notice sends the admin. The PIP page passes `intro` and
// `add` through to the embedded app (containers/ProductImprovementPage).
export const PIP_TOUR_PATH = '/tipdirect/product-improvement?intro=1';
export const PIP_ADD_TOUR_PATH = '/tipdirect/product-improvement?page=products&add=1';

export const pipCreditsDestination = notice => (notice?.kind === 'welcome' ? PIP_TOUR_PATH : PIP_ADD_TOUR_PATH);
